import * as Immutable from "immutable";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { TeamSync, TeamSyncBackends } from "@graylog/enterprise-api";
import Team from "../../security/logic/Team";
export const SYNCED_TEAMS_QUERY_KEY = ["authentication", "synced-teams"];
export const loadSyncedTeamsPaginated = (authBackendId, { page: newPage, perPage: newPerPage, query: newQuery }) => TeamSyncBackends.getUsers(void 0, authBackendId, newPage, newPerPage, newQuery).then(
  ({ teams, context, page, per_page: perPage, query, count, total }) => ({
    list: Immutable.List(teams.map((user) => Team.fromJSON(user))),
    context: {
      roles: Immutable.Map(context == null ? void 0 : context.roles),
      users: Immutable.Map(context == null ? void 0 : context.users)
    },
    pagination: {
      page,
      perPage,
      query,
      count,
      total
    }
  })
);
export const useSyncedTeamsPaginated = (authBackendId, pagination) => useQuery({
  queryKey: [...SYNCED_TEAMS_QUERY_KEY, authBackendId, pagination],
  queryFn: () => loadSyncedTeamsPaginated(authBackendId, pagination),
  placeholderData: keepPreviousData
});
export const triggerTeamSync = (backendId, _backendTitle) => TeamSync.triggerSync(backendId).then(
  ({
    success,
    message,
    errors,
    created_teams: createdTeams,
    deleted_teams: deletedTeams,
    updated_teams: updatedTeams
  }) => ({
    success,
    message,
    errors,
    createdTeams,
    deletedTeams,
    updatedTeams
  })
);
